import * as React from 'react';

interface NotFoundProps {
  onLoading: (loading: boolean) => void;
}
interface NotFoundState {}

export class NotFound extends React.Component<NotFoundProps, NotFoundState> {
  constructor(props: NotFoundProps) {
    super(props);
    this.state = {};
  }

  componentDidMount() { this.props.onLoading(false); }

  render() {
    return (
      <section className="panel panel-error">
        <header className="panel-heading">
            <i className="fa fa-minus-circle"/>

            <h2 className="alert-heading">Oops, we can't find this page!</h2>
        </header>

        <div className="panel-body">
            <p>It looks like the page you are looking for does not exist.</p>

            <p>
                If you believe you have received this message in error, please contact{' '}
                <a href="mailto:gsit@ucdavis.edu?subject=Page%20Not%20Found">technical support</a>.
            </p>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/gs-core/client/react/error/NotFound.tsx